import React, { useEffect, useRef } from 'react';
import { useGeneratesMenu } from './useGeneratesMenu';

interface PdfContentMenuDropdownProps {
  containerRef: React.RefObject<HTMLDivElement>;
  closeDropdown: () => void;
}

export const PdfContentMenuDropdown: React.FC<PdfContentMenuDropdownProps> = ({
  containerRef,
  closeDropdown,
}) => {
  const { menuItems, handleScroll } = useGeneratesMenu(containerRef);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClick = (id: string) => {
    handleScroll(id);
    if (closeDropdown) closeDropdown();
  };

  const handleClickOutside = (e: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target as Node)
    ) {
      closeDropdown();
    }
  };

  useEffect(() => {
    if (window.innerWidth < 768) {
      document.body.classList.add('overflow-hidden');
    }
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="dropdown-content max-h-60 overflow-auto">
      <ul className=" absolute flex flex-col gap-3 pb-4 pt-2 w-full overflow-auto shadow-lg bg-white md:w-fit max-h-screen">
        {menuItems.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className=" ml-2 text-lg px-2 font-semibold no-underline hover:underline  "
              onClick={(e) => {
                e.preventDefault();
                handleClick(item.id!);
              }}
            >
              {item.title}
            </a>
            <div className="border-b-2 pb-4 mb-2 w-full"></div>
            {item.children && item.children.length > 0 && (
              <ul>
                {item.children.map((child) => (
                  <li className="pb-2 px-8 space-y-1" key={child.id}>
                    <a
                      href={`#${child.id}`}
                      className="no-underline hover:underline"
                      onClick={(e) => {
                        e.preventDefault();
                        handleClick(child.id!);
                      }}
                    >
                      {child.title}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
